module.exports = __webpack_public_path__ + "img/news-sample2.83dd76e8.svg";